import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import CloudSyncIcon from '@mui/icons-material/Sync';
import { Upload as UploadIcon } from '@mui/icons-material';
import { useEntryImportMutation } from '../services/records';
import { storeLocalEntries } from '../localStorage';
import { Entry } from '../types';

type SyncOfflineDataDialogProps = {
	open: boolean;
	records: Entry[];
	onClose: () => void;
	onNotNow: () => void;
	onSynced: () => void;
};

function SyncOfflineDataDialog({ open, records, onClose, onNotNow, onSynced }: SyncOfflineDataDialogProps) {
	const [entryImportMutation, { isLoading: isEntryImportInProgress }] = useEntryImportMutation();

	const handleConfirm = async () => {
		try {
			await entryImportMutation(records as any).unwrap();
			storeLocalEntries([]);
			onSynced();
		} catch (error) {
			console.error('Failed to sync local records to cloud', error);
		}
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
			<DialogTitle sx={{display: 'flex', alignItems: 'center', gap: 1}}><UploadIcon />Upload offline work?</DialogTitle>
			<DialogContent>
				<DialogContentText>
					This device contains some work created in offline mode. Would you like to move it into your cloud workspace?
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onNotNow} disabled={isEntryImportInProgress}>Not now</Button>
				<Button onClick={handleConfirm} variant='contained' disabled={isEntryImportInProgress} startIcon={<CloudSyncIcon />}>
					{isEntryImportInProgress ? 'importing...' : 'Yes, import'}
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default SyncOfflineDataDialog;
